import { LogOut, Moon, Sun, Monitor } from 'lucide-react';
import { useCallback, useState } from 'react';
import { useAuth } from '@/hooks/useAuth';
import { useUIStore } from '@/stores/ui';

export function Header() {
  const { user, signOut } = useAuth();
  const { theme, setTheme } = useUIStore();
  const [menuOpen, setMenuOpen] = useState(false);

  const handleSignOut = useCallback(async () => {
    setMenuOpen(false);
    await signOut();
  }, [signOut]);

  const cycleTheme = useCallback(() => {
    const themes: ('light' | 'dark' | 'system')[] = ['light', 'dark', 'system'];
    const currentIndex = themes.indexOf(theme);
    const nextTheme = themes[(currentIndex + 1) % themes.length];
    setTheme(nextTheme ?? 'system');
  }, [theme, setTheme]);

  const ThemeIcon = theme === 'dark' ? Moon : theme === 'light' ? Sun : Monitor;

  return (
    <header className="flex h-14 items-center justify-end border-b border-slate-200 bg-white px-6 dark:border-slate-800 dark:bg-black">
      <div className="relative">
        <button
          onClick={() => setMenuOpen(!menuOpen)}
          className="flex h-8 w-8 items-center justify-center rounded-full bg-surface-selected text-sm font-medium text-slate-600 hover:bg-surface-hover dark:bg-surface-selected-dark dark:text-slate-300 dark:hover:bg-surface-hover-dark"
        >
          {user?.name?.[0]?.toUpperCase() || user?.email?.[0]?.toUpperCase() || '?'}
        </button>

        {menuOpen && (
          <>
            <div className="fixed inset-0 z-40" onClick={() => setMenuOpen(false)} />
            <div className="absolute right-0 top-full z-50 mt-2 w-56 rounded-button border border-slate-200 bg-white py-1 shadow-lg dark:border-slate-700 dark:bg-black">
              <div className="border-b border-slate-200 px-4 py-3 dark:border-slate-700">
                <p className="text-sm font-medium text-slate-900 dark:text-white">
                  {user?.name || 'User'}
                </p>
                <p className="text-xs text-slate-500 dark:text-slate-400">{user?.email}</p>
              </div>

              <button
                onClick={cycleTheme}
                className="flex w-full items-center gap-3 px-4 py-2 text-sm text-slate-700 hover:bg-surface-hover dark:text-slate-300 dark:hover:bg-surface-hover-dark"
              >
                <ThemeIcon className="h-4 w-4" />
                <span>Theme: {theme.charAt(0).toUpperCase() + theme.slice(1)}</span>
              </button>

              <button
                onClick={handleSignOut}
                className="flex w-full items-center gap-3 px-4 py-2 text-sm text-red-600 hover:bg-red-50 dark:text-red-400 dark:hover:bg-red-950"
              >
                <LogOut className="h-4 w-4" />
                <span>Sign out</span>
              </button>
            </div>
          </>
        )}
      </div>
    </header>
  );
}
